import React from 'react';
import { Desktop } from '@kizi/comparator-components';
import { Div } from '@kizi/core-components';
import { Checkbox } from '@kizi/shared-components';

export const DesktopCompareCheck = (data: any, onChange) => {
  return (
    <Desktop>
      <Div display="flex" alignItems="center" justifyContent="left" mt={[2]}>
        <Checkbox
          mr={2}
          variant="main"
          label="Vergelijk"
          id={`compare-id-${data?.id}`}
          labelPosition="right"
          containerProps={{
            fontFamily: "'Segoe UI', sans-serif",
          }}
          checked={data.compare}
          onChange={(e) => {
            window?.dataLayer?.push({
              event: 'compare_product',
              event_action: 'Checked',
              event_label: 'Vergelijk',
              event_category: 'Funnel - HealthCare',
              component: 'Product or Top 3 product',
              comparison_id: '14081a82-217a-4927-b187-656ab23dbcca',
            });
            onChange(e, data.id);
          }}
        />
      </Div>
    </Desktop>
  );
};
